module.exports = __webpack_public_path__ + "static/img/jx@2x.18b3cbe4.png";